export default {
  deviceFullHeight: window.innerHeight,
  userDetails: {},
  token: '',
  rememberme: null
}